module.exports = [{"name":"PPARK1907_SP_ONE_CLICK","version":1},{"name":"PPARK1933_DESKTOP_ITERATION","version":1}]